module.exports = __webpack_public_path__ + "static/MainPage-cdb8672f5b2d55f48607b9863255b2b9.png";